import { Link } from 'react-router-dom';
import { useCotaDeConsultas } from '../api/queries.js';
import { PageHeader } from '../components/PageHeader.js';

/**
 * A escolha ao tocar no "+": guardar ou só saber.
 *
 * **Por que aqui e não um quinto item na barra.** A barra tem quatro itens e foi
 * afinada: o "+" já é a ação principal, com destaque próprio e ao alcance do
 * polegar. Um quinto espremeria todos e diluiria justamente esse destaque.
 *
 * E as duas ações **começam igual** — apontar a câmera para um rótulo —, então
 * bifurcar aqui é honesto, não é esconder uma coisa dentro da outra.
 *
 * **O custo, declarado:** cadastrar ganha um toque a mais. Vale porque a escolha
 * é instantânea e porque a consulta fica descoberta por todo mundo, sem
 * precisar procurar.
 */
export function NovaGarrafa() {
  const { data: cota } = useCotaDeConsultas();

  return (
    <div className="space-y-4">
      <PageHeader
        titulo="Esta garrafa na sua mão"
        subtitulo="Nos dois casos você começa fotografando o rótulo"
        voltar="/"
      />

      <Link to="/adicionar" className="card block space-y-1 active:border-adega-wine-light">
        <p className="font-semibold">Vou guardar esta</p>
        <p className="text-sm leading-relaxed text-adega-muted">
          Cadastra na adega e escolhe a posição, como sempre.
        </p>
      </Link>

      <Link
        to="/consultar"
        className="card block space-y-1 border-adega-wine-light/60 active:border-adega-wine-light"
      >
        <p className="font-semibold">Só quero saber</p>
        <p className="text-sm leading-relaxed text-adega-muted">
          Lê o rótulo e responde se vale levar.{' '}
          <strong className="font-semibold text-adega-text">Não guarda nada.</strong>
        </p>
        {/* A cota aparece já na escolha: quem está no mercado decide sabendo
            quanto ainda tem, em vez de descobrir no erro. */}
        {cota ? (
          <p className="pt-1 text-xs text-adega-gold">
            {cota.restantes > 0
              ? `Restam ${cota.restantes} de ${cota.limite} consultas este mês`
              : `Sem consultas este mês — a conta vira no dia 1º`}
          </p>
        ) : null}
      </Link>
    </div>
  );
}
